import { mapState } from 'vuex';
import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue'
import EeiregReport from '@/components/eeireg/report/EeiregReport.vue'
import EeiregInvlidClients from '@/components/eeireg/invalidclients/EeiregInvlidClients.vue';
import ScheduledTasksQueueList from '@/components/admin/scheduletasks/queuelist/ScheduledTasksQueueList.vue';

export default {
  name: 'EeriregList',
  data () {
    return {
      isMounted: false,
      loading: true,
      clients: null,
      missingClients: null,
      fromPeriod: null,
      periods: [],
      currentReq: null,
      filters: {
        name: '',
        manager: null,
        clientIsInReg: null,
        forms: [],
        modifiedAfterSend: null
      }
    }
  },
  components: {
    DatePeriodPicker,
    EeiregReport,
    EeiregInvlidClients,
    ScheduledTasksQueueList
  },
  computed: {
    ...mapState(['config']),
    requestPath () {
      return 'eeireg/list/' + this.$route.meta.reqpath + '/' + this.fromPeriod;
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-eeireg');
    },
    invalidReportStatuses () {
      const statusIds = [];
      if (this.config && this.config.client_report_statuses) {
        Object.values(this.config.client_report_statuses).forEach(function (el) {
          if (el.code === 'EMPTY' || el.code === 'REJECTED') {
            statusIds.push(el.id);
          }
        });
      }
      return statusIds;
    },
    materialGroupId () {
      return this.$store.getters.getParamFromConfigByFilter('material_groups', 'code', this.$route.meta.reqpath, 'id');
    },
    forms () {
      return this.$store.getters.getItemsFromConfigWithFilter('eeireg_forms', 'material_group_id', this.materialGroupId);
    },
    managerOptions () {
      const options = this.$store.getters.getConfigOptions('managers');
      options.unshift({ text: '', value: null });
      return options;
    },
    yesNoOptions () {
      const options = this.BasicHelper.yesNoOptions();
      options.unshift({ code: null, text: '' });
      return options;
    },
    sendStatusOptions () {
      return [
        { code: null, text: '' },
        { code: '0', text: this.$t('eeireg.form-status.not-sent') },
        { code: '1', text: this.$t('eeireg.form-status.error') },
        { code: '2', text: this.$t('eeireg.form-status.already-sent') },
        { code: '100', text: this.$t('eeireg.form-status.success') }
      ];
    },
    toPeriod () {
      return this.BasicHelper.getNextDatePeriod(this.fromPeriod);
    },
    tableHeaders () {
      const res = [
        { key: 'modifiedAfterSend', label: this.$t('eeireg.report.modified'), type: 'slot', slotcode: 'modifiedAfterSend', localFilter: true, options: this.yesNoOptions, searchFunc: this.getYesNoFilterText },
        { key: 'name', label: this.$t('client.name'), type: 'slot', slotcode: 'clientname', localFilter: true, searchFunc: this.getSearchClientname },
        { key: 'registryNumber', label: this.$t('client.registryNumber'), type: 'slot', slotcode: 'registryNumber', localFilter: true, searchFunc: this.getSearchClientRegistry }
      ];
      Object.values(this.periods).forEach(period => {
        res.push({
          key: 'reports.' + period,
          label: this.$tc('general.datePeriod.short', this.BasicHelper.datePeriodCodeToData(period).period, this.BasicHelper.datePeriodCodeToData(period)),
          type: 'slot',
          slotcode: 'report'
        })
      });
      res.push({ key: 'eei', label: this.$t('eeireg.clientIsInReg'), type: 'slot', slotcode: 'ineei', localFilter: true, options: this.yesNoOptions, searchFunc: this.getYesNoFilterText });

      Object.values(this.forms).forEach(form => {
        res.push({
          key: 'eei_records.' + form.id,
          label: this.BasicHelper.getTranslation(form.name),
          type: 'slot',
          slotcode: 'eei_form',
          localFilter: true,
          options: this.sendStatusOptions,
          searchFunc: this.getYesNoEiiFilterTxt,
          searchExact: true
        })
      });
      res.push({ key: 'eei_actions', label: '', type: 'slot', slotcode: 'eei_actions', class: 'col-width-large' });
      return res;
    },
    formModelClassId () {
      return this.$store.getters.getDataFromConfigById('model_classes', 'eeireg_forms');
    }
  },
  methods: {
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      if (this.fromPeriod) {
        this.loading = true;
        const self = this;
        this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, [], function (response) {
          if (response.data) {
            self.periods = response.data.periods;
            self.clients = response.data.clients;
            self.missingClients = response.data.missing_clients;
            self.loading = false;
          }
        })
      } else {
        this.clients = [];
        this.periods = [];
        this.missingClients = [];
      }
    },
    getReportStatusClass (statusId) {
      if (this.invalidReportStatuses.indexOf(statusId) >= 0) {
        return 'text-error';
      }
      return 'text-success'
    },
    clearFilters () {
      this.filters.name = '';
      this.filters.manager = null;
      this.filters.clientIsInReg = null;
      const self = this;
      Object.keys(this.filters.forms).forEach(key => {
        self.filters.forms[key] = null;
      });
      if (this.filteredClients) {
        this.$forceUpdate();
      }
    },
    sendForm (client, form) {
      if (!this.canEdit) {
        return;
      }
      const periodStr = this.BasicHelper.getDatePeriodRangeFormatted(this.fromPeriod, this.toPeriod);
      this.$refs.sendFormMsgBox.show(
        { client_id: client.id, eeireg_form: form.code, from_date_period_id: this.fromPeriod },
        this.$t('eeireg.actions.send-approve.title'),
        this.$t('eeireg.actions.send-approve.message', { name: client.name, period: periodStr, formname: this.BasicHelper.getTranslation(form.name) })
      )
    },
    queueSendForm (data, approved = false) {
      if (approved) {
        const self = this;
        this.ApiRequest.request('eeireg/queue', this.ApiRequest.REQUEST_POST, data, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self)
          } else {
            self.ApiRequest.displaySuccessDialog(
              self,
              self.$t('eeireg.actions.queue-send.message-success'),
              self.$t('eeireg.actions.queue-send.title-success')
            )
          }
        });
      } else {
        const periodStr = this.BasicHelper.getDatePeriodRangeFormatted(this.fromPeriod, this.toPeriod);
        this.$refs.queueSendMessageBox.show(
          { eeireg_form: data.code, from_date_period_id: this.fromPeriod },
          this.$t('eeireg.actions.queue-send.title'),
          this.$t('eeireg.actions.queue-send.message', { period: periodStr, formname: this.BasicHelper.getTranslation(data.name) })
        )
      }
    },
    sendFormApproved (data) {
      const self = this;
      const clientEl = this.clients.find(el => el.id === data.client_id);
      if (clientEl) {
        clientEl.loading = true;
      }
      this.$refs.tableview.$forceUpdate();
      this.ApiRequest.request('eeireg/send-form', this.ApiRequest.REQUEST_POST, data, function (response) {
        if (response.data) {
          if (clientEl) {
            if (!clientEl.eei_records) {
              clientEl.eei_records = [];
            }
            Object.values(response.data).forEach(function (el) {
              clientEl.eei_records[el.eeireg_form_id] = el;
            })
          }
        } else if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self)
        }
        if (clientEl) {
          clientEl.loading = false;
        }
        if (self.$refs.tableview) {
          self.$refs.tableview.$forceUpdate();
        }
      });
    },
    showReport (clientId) {
      this.$refs.reportFrm.setData(clientId, this.fromPeriod);
    },
    showInvalidClients () {
      this.$refs.invalidClients.setData(this.fromPeriod);
    },
    showQueueList () {
      this.$refs.scheduleTaskQueueList.show();
    },
    viewreport (item, datePeriodId, clientReport, newtab = false) {
      const clientId = item.api_id
      const reportCode = this.$store.getters.getParamFromConfig('report_configs', clientReport.report_config_id, 'code');
      if (newtab) {
        const routeData = this.$router.resolve({ name: 'menu.client.report', params: { clientApiId: clientId, reportCode: reportCode, datePeriodCode: datePeriodId } });
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push('/client/' + clientId + '/report/' + reportCode + '/' + datePeriodId);
      }
    },
    getSearchClientname (text, el) {
      if (el.eei) {
        text += ' ' + el.eei.title + ' (' + el.eei.eeiregId + ')';
      }
      return text;
    },
    getSearchClientRegistry (text, el) {
      if (el.registryNumberEeireg) {
        text += ' ' + el.registryNumberEeireg;
      }
      return text;
    },
    getYesNoFilterText (text, el, filterKey) {
      if (text) {
        return '1';
      }
      return '0';
    },
    getYesNoEiiFilterTxt (text, el, filterKey) {
      if (text && text.last_status) {
        return text.last_status + '';
      }
      return '0';
    },
    getFormStatusClass (formId, eeiForms) {
      if (eeiForms && eeiForms[formId]) {
        if (eeiForms[formId].last_status == 100) {
          return 'primary';
        } else if (eeiForms[formId].last_status == 2) {
          return 'secondary';
        }
        return 'error';
      }
      return 'warning';
    }
  },
  watch: {
    '$route' () {
      this.getTableData();
    }
  },
  mounted () {
    const currentDatePeriodId = (this.config.currentDatePeriod ? this.config.currentDatePeriod.id : 0);
    if (currentDatePeriodId) {
      const periodData = this.BasicHelper.datePeriodCodeToData(currentDatePeriodId);
      if (periodData.period < 3) {
        this.fromPeriod = (periodData.year - 1) + '030';
      } else {
        this.fromPeriod = periodData.year + '010';
      }
    }
    this.isMounted = true;
    this.getTableData();
  }
}
